import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import accountStore from "./store/accountStore";
import appStore from "../../stores/appStore";
import { Helmet } from "react-helmet-async";
import AccountNavigation from "./components/AccountNavigation";
import { Outlet, useLocation } from "react-router";

const AccountPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Эффект для загрузки заказов при монтировании и изменении авторизации
  useEffect(() => {
    if (appStore.isLoginIn) {
      accountStore.getOrders();
    } else {
      // Очищаем заказы при выходе из системы
      accountStore.orders = [];
    }

    appStore.getUser();
  }, [localStorage.getItem("access_token")]); // Зависимость от состояния авторизации

  useEffect(() => {
    console.log(appStore.isLoginIn);
  }, [appStore.isLoginIn]);

  // Стили для мобильных устройств
  const mobileStyles = {
    container: isMobile ? "flex-col p-[15px] gap-[25px]" : "flex-row p-[20px] pt-[30px] gap-[30px]",
    sidebar: isMobile
      ? "flex-row w-full overflow-x-auto gap-4 p-2 bg-white rounded-lg"
      : "flex-col rounded-2xl h-max bg-white p-[20px] gap-[20px] min-w-[250px] shadow-[0_2px_20px_#0000001a]",
    menuItem: isMobile
      ? "text-base whitespace-nowrap"
      : "text-[18px] tracking-[-2%]",
    content: isMobile ? "w-full mt-2" : " w-[800px] text-[#232323]",
    orderCard: isMobile
      ? "flex-col gap-2 p-3 border-b border-gray-100"
      : "flex-row justify-around mb-4 p-2 border-b border-dashed",
    orderInfo: isMobile ? "flex-row justify-between w-full" : "flex-1",
    deliveryInfo: isMobile
      ? "w-full text-sm"
      : "flex-1 min-w-[400px] justify-center",
    priceInfo: isMobile
      ? "flex-row justify-between items-center mt-2"
      : "flex-col flex-1",
  };

  const location = useLocation();

  return (
    <div className={`flex ${mobileStyles.container}`}>
      <Helmet>
        <>
          <title>КЦ Авто | Аккаунт</title>
          <meta
            name="description"
            content={`КЦ авто аккаунт профиль купить автозапчасти Корея центр`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти, профиль КЦ Авто, КЦ авто аккаунт"
          />
        </>
      </Helmet>
      {/* Боковое меню */}
      {(location.pathname.includes('orders') && isMobile)  ? (
        <></>
      ): (
        <AccountNavigation></AccountNavigation>
      )}

      <Outlet></Outlet>
    </div>
  );
};

export default observer(AccountPage);
